import React, { useState, createContext, useContext } from "react";
import localData from "./localData";
import emailjs from "@emailjs/browser";
export const Context = createContext();

export default function Provider({ children }) {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [state, setState] = useState({
        fetchedData: null,
        localData,
    });

    const [animations, setAnimations] = useState({
        fade: {
            initial:{ opacity: 0 },
            animate:{ opacity: 1 },
            exit:{ opacity: 0 },
            transition:{ duration: 0.5 }
        },
    });

    const [isModalShown, setIsModalShown] = useState(false);

    
    // ALERT
    const [alert, setAlert] = useState({
        type: "success",
        message: "",
    });
    const [alertTimeout, setAlertTimeout] = useState(null);

    const createAlert = ({ success, message }) => {
        setAlert({ ...alert, message, type: success ? "dark" : "danger" });
        clearTimeout(alertTimeout);
        setAlertTimeout(setTimeout(() => setAlert({ ...alert, message: "" }), 3000));
    };

    const sendEmail = (form,e) => {
        e.preventDefault()
        emailjs.sendForm("service_po5yhfu", "template_zl57oob", form.current, "T5mWrXCF1fyxocg67").then(
            (result) => {
                createAlert({ success: true, message: "thanks for submitting!" });
            },
            (error) => {
                createAlert({ success: false, message: "error" });
                alert(error.text)
            }
        );
    };
    const sendSubscriberEmail = (form,e) => {
        e.preventDefault()
        emailjs.sendForm("service_po5yhfu", "template_px3stvc", form.current, "T5mWrXCF1fyxocg67").then(
            (result) => {
                createAlert({ success: true, message: "thanks for submitting!" });
            },
            (error) => {
                createAlert({ success: false, message: "error" });
                alert(error.text)
            }
        );
    };


    return (
        <Context.Provider
            value={{
                state,
                ...state,
                setState,
                isLoggedIn,
                setIsLoggedIn,
                animations,
                isModalShown,
                setIsModalShown,
                createAlert,
                alert,
                setAlert,
                sendEmail,
                sendSubscriberEmail
            }}
        >
            {children}
        </Context.Provider>
    );
}

export const useGlobalContext = () => useContext(Context);
